export const selectVisibilityInvoices = (state) => state.visibility.visibilityInvoices;

export const selectVisibilitySuppliers = (state) =>state.visibility.visibilitySuppliers;

export const selectVisibilityClientsInWork = (state) => state.visibility.visibilityClientsInWork;

export const selectVisibilityAllClients = (state) => state.visibility.visibilityAllClients;

export const selectVisibilityCar = (state) => state.visibility.visibilityCar;

export const selectVisibilityRecords = (state) => state.visibility.visibilityRecords;

export const selectVisibilityArchive = (state) => state.visibility.visibilityArchive;

export const selectVisibilityRecomendations = (state) => state.visibility.visibilityCarRecomendations;

export const selectVisibilityDashBoard = (state) => state.visibility.visibilityDashBoard;
